import React from "react";

const RelocationForm = ({ formData, handleChange }) => {
    const handleLocalChange = (e) => {
        const { name, value } = e.target;

        // Phone masking for patientContact: digits only, max 11, format xxxx-xxxxxxx
        if (name === "patientContact") {
            const digits = value.replace(/\D/g, "").slice(0, 11);
            const finalValue = digits.length <= 4 ? digits : `${digits.slice(0, 4)}-${digits.slice(4)}`;
            handleChange({ target: { name, value: finalValue } });
            return;
        }

        handleChange(e);
    };

    return (
        <>
            <div className="p-3" style={{ maxHeight: "65vh", overflowY: "auto", scrollbarWidth: "thin" }}>
                <div className="accordion" id="relocationAccordion">

                    {/* Header / Standard Information */}
                    <div className="accordion-item mb-3 shadow-sm rounded">
                        <h2 className="accordion-header">
                            <button className="accordion-button fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#headerInfo">
                                Document Header
                            </button>
                        </h2>
                        <div id="headerInfo" className="accordion-collapse collapse show">
                            <div className="accordion-body pt-3">
                                <div className="row g-3">
                                    <div className="col-md-4">
                                        <div className="form-floating form-floating-outline">
                                            <input type="text" className="form-control" name="standardName" value={formData.standardName || ""} onChange={handleChange} />
                                            <label>Standard Name</label>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-floating form-floating-outline">
                                            <input type="date" className="form-control" name="issueDate" value={formData.issueDate || ""} onChange={handleChange} />
                                            <label>Issue Date</label>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-floating form-floating-outline">
                                            <input type="date" className="form-control" name="reviewDate" value={formData.reviewDate || ""} onChange={handleChange} />
                                            <label>Review Date</label>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-floating form-floating-outline">
                                            <input type="text" className="form-control" name="documentNumber" value={formData.documentNumber || ""} onChange={handleChange} />
                                            <label>Document #</label>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-floating form-floating-outline">
                                            <input type="text" className="form-control" name="revisionNumber" value={formData.revisionNumber || ""} onChange={handleChange} />
                                            <label>Rev #</label>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-floating form-floating-outline">
                                            <input type="text" className="form-control" name="departmentName" value={formData.departmentName || ""} onChange={handleChange} />
                                            <label>Department</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Patient Information */}
                    <div className="accordion-item mb-3 shadow-sm rounded">
                        <h2 className="accordion-header">
                            <button className="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#patientInfo">
                                Patient Information
                            </button>
                        </h2>
                        <div id="patientInfo" className="accordion-collapse collapse">
                            <div className="accordion-body pt-3">
                                <div className="row g-3">
                                    <div className="col-md-3">
                                        <div className="form-floating form-floating-outline">
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="patientName"
                                                value={formData.patientName || ""}
                                                onChange={handleChange}
                                                readOnly={!!formData.patientId || !!formData.patient_id}
                                            />
                                            <label>Name</label>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-floating form-floating-outline">
                                            <select
                                                className="form-select"
                                                name="patientGender"
                                                value={formData.patientGender?.toLowerCase() || ""}
                                                onChange={handleChange}
                                                disabled={!!formData.patientId || !!formData.patient_id}
                                            >
                                                <option value="">Select Gender</option>
                                                <option value="male">Male</option>
                                                <option value="female">Female</option>
                                                <option value="other">Other</option>
                                            </select>
                                            <label>Gender</label>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-floating form-floating-outline">
                                            <input
                                                type="date"
                                                className="form-control"
                                                name="patientDob"
                                                value={formData.patientDob || ""}
                                                onChange={handleChange}
                                                readOnly={!!formData.patientId || !!formData.patient_id}
                                            />
                                            <label>Date of Birth</label>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-floating form-floating-outline">
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="patientContact"
                                                value={formData.patientContact || ""}
                                                onChange={handleLocalChange}
                                                readOnly={!!formData.patientId || !!formData.patient_id}
                                            />
                                            <label>Contact</label>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                    <div className="form-floating form-floating-outline">
                                        <textarea
                                            className="form-control"
                                            name="currentMedication"
                                            value={formData.currentMedication || ""}
                                            onChange={handleChange}
                                            rows="4"
                                        />
                                        <label>Current Medication</label>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* On-Duty Doctor / Consultant Section */}
                    <div className="accordion-item mb-3 shadow-sm rounded">
                        <h2 className="accordion-header">
                            <button className="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#onDutySection">
                                To be filled by the On-Duty Doctor / Consultant
                            </button>
                        </h2>
                        <div id="onDutySection" className="accordion-collapse collapse">
                            <div className="accordion-body pt-3">
                                <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block my-4">
                                    Injections / Tablets
                                </small>

                                <div className="row g-3">
                                    {[
                                        { key: "quetiapine", label: "Tab Quetiapine", type: "TABLET" },
                                        { key: "serenace", label: "Inj Serenace", type: "INJECTION" },
                                        { key: "avil", label: "Inj Avil", type: "INJECTION" },
                                        { key: "clopixol", label: "Inj Clopixol Accuphase/Depot", type: "INJECTION" },
                                        { key: "dormicum", label: "Inj Dormicum", type: "INJECTION" },
                                        { key: "vallium", label: "Inj Vallium", type: "INJECTION" },
                                        { key: "procyclidine", label: "Tab Procyclidine", type: "TABLET" },
                                    ].map(({ key, label, type }) => (
                                        <div className="col-md-6" key={key}>
                                            <div className="border rounded-4 p-4 bg-light-subtle text-center h-100">
                                                <div className="fw-bold mb-3">{label}</div>
                                                <div className="d-flex justify-content-center gap-4 mb-3">
                                                    {["Yes", "No"].map((opt) => (
                                                        <div className="form-check form-check-inline" key={opt}>
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name={key}
                                                                id={`${key}-${opt}`}
                                                                value={opt}
                                                                checked={formData[key] === opt}
                                                                onChange={handleChange}
                                                            />
                                                            <label className="form-check-label" htmlFor={`${key}-${opt}`}>
                                                                {opt}
                                                            </label>
                                                        </div>
                                                    ))}
                                                </div>
                                                {formData[key] === "Yes" && (
                                                    <div className="row g-3 justify-content-center">
                                                        <div className="col-md-8">
                                                            <div className="form-floating form-floating-outline">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    name={`${key}Dose`}
                                                                    value={formData[`${key}Dose`] || ""}
                                                                    onChange={handleChange}
                                                                    placeholder="Dose"
                                                                />
                                                                <label>Dose</label>
                                                            </div>
                                                        </div>
                                                        {type === "INJECTION" && (
                                                            <div className="col-md-12 mt-2">
                                                                {["IV", "IM"].map((t) => (
                                                                    <div className="form-check form-check-inline" key={t}>
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="radio"
                                                                            name={`${key}Type`}
                                                                            id={`${key}${t}`}
                                                                            value={t}
                                                                            checked={formData[`${key}Type`] === t}
                                                                            onChange={handleChange}
                                                                        />
                                                                        <label className="form-check-label" htmlFor={`${key}${t}`}>
                                                                            {t}
                                                                        </label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                        {type === "TABLET" && (
                                                            <div className="col-md-12 mt-2">
                                                                <small className="fw-semibold text-primary">ORAL</small>
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <div className="col-md-12 mt-4">
                                    <div className="form-floating form-floating-outline">
                                        <textarea
                                            className="form-control"
                                            name="doctorRemarks"
                                            value={formData.doctorRemarks || ""}
                                            onChange={handleChange}
                                            rows="4"
                                        />
                                        <label>Remarks</label>
                                    </div>
                                </div>

                                <div className="col-md-12 mt-4">
                                    <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3">
                                        On-Duty Doctor / Consultant Signature
                                    </small>
                                </div>
                                <div className="row g-3">
                                    <div className="col-md-4">
                                        <div className="form-floating form-floating-outline">
                                            <input type="text" className="form-control" name="doctorName" value={formData.doctorName || ""} onChange={handleChange} />
                                            <label>Name</label>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-floating form-floating-outline">
                                            <select className="form-select" name="doctorDesignation" value={formData.doctorDesignation || ""} onChange={handleChange}>
                                                <option value="">Select Designation</option>
                                                <option value="Consultant Psychiatrist">Consultant Psychiatrist</option>
                                                <option value="Medical Officer">Medical Officer</option>
                                            </select>
                                            <label>Designation</label>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-floating form-floating-outline">
                                            <input type="text" className="form-control" name="doctorPlace" value={formData.doctorPlace || ""} onChange={handleChange} />
                                            <label>Place of Administration</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Assigned RN / A.N Section */}
                    <div className="accordion-item mb-3 shadow-sm rounded">
                        <h2 className="accordion-header">
                            <button className="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#rnSection">
                                To be filled by the Assigned RN / A.N
                            </button>
                        </h2>
                        <div id="rnSection" className="accordion-collapse collapse">
                            <div className="accordion-body pt-3">
                                <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block my-4">
                                    Injections / Tablets
                                </small>

                                <div className="row g-3">
                                    {[
                                        { key: "rnQuetiapine", label: "Tab Quetiapine", type: "TABLET" },
                                        { key: "rnSerenace", label: "Inj Serenace", type: "INJECTION" },
                                        { key: "rnAvil", label: "Inj Avil", type: "INJECTION" },
                                        { key: "rnClopixol", label: "Inj Clopixol Accuphase/Depot", type: "INJECTION" },
                                        { key: "rnDormicum", label: "Inj Dormicum", type: "INJECTION" },
                                        { key: "rnVallium", label: "Inj Vallium", type: "INJECTION" },
                                        { key: "rnProcyclidine", label: "Tab Procyclidine", type: "TABLET" },
                                    ].map(({ key, label, type }) => (
                                        <div className="col-md-6" key={key}>
                                            <div className="border rounded-4 p-4 bg-light-subtle text-center h-100">
                                                <div className="fw-bold mb-3">{label}</div>
                                                <div className="d-flex justify-content-center gap-4 mb-3">
                                                    {["Yes", "No"].map((opt) => (
                                                        <div className="form-check form-check-inline" key={opt}>
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name={key}
                                                                id={`${key}-${opt}`}
                                                                value={opt}
                                                                checked={formData[key] === opt}
                                                                onChange={handleChange}
                                                            />
                                                            <label className="form-check-label" htmlFor={`${key}-${opt}`}>
                                                                {opt}
                                                            </label>
                                                        </div>
                                                    ))}
                                                </div>
                                                {formData[key] === "Yes" && (
                                                    <div className="row g-3 justify-content-center">
                                                        <div className="col-md-8">
                                                            <div className="form-floating form-floating-outline">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    name={`${key}Dose`}
                                                                    value={formData[`${key}Dose`] || ""}
                                                                    onChange={handleChange}
                                                                    placeholder="Dose"
                                                                />
                                                                <label>Dose</label>
                                                            </div>
                                                        </div>
                                                        {type === "INJECTION" && (
                                                            <div className="col-md-12 mt-2">
                                                                {["IV", "IM"].map((t) => (
                                                                    <div className="form-check form-check-inline" key={t}>
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="radio"
                                                                            name={`${key}Type`}
                                                                            id={`${key}${t}`}
                                                                            value={t}
                                                                            checked={formData[`${key}Type`] === t}
                                                                            onChange={handleChange}
                                                                        />
                                                                        <label className="form-check-label" htmlFor={`${key}${t}`}>
                                                                            {t}
                                                                        </label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                        {type === "TABLET" && (
                                                            <div className="col-md-12 mt-2">
                                                                <small className="fw-semibold text-primary">ORAL</small>
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <div className="col-md-12 mt-4">
                                    <div className="form-floating form-floating-outline">
                                        <textarea
                                            className="form-control"
                                            name="rnRemarks"
                                            value={formData.rnRemarks || ""}
                                            onChange={handleChange}
                                            rows="4"
                                        />
                                        <label>Remarks</label>
                                    </div>
                                </div>

                                <div className="col-md-12 mt-4">
                                    <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3">
                                        Assigned RN / Dispenser Signature
                                    </small>
                                </div>
                                <div className="row g-3">
                                    <div className="col-md-4">
                                        <div className="form-floating form-floating-outline">
                                            <input type="text" className="form-control" name="rnName" value={formData.rnName || ""} onChange={handleChange} />
                                            <label>Name</label>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-floating form-floating-outline">
                                            <select className="form-select" name="rnDesignation" value={formData.rnDesignation || ""} onChange={handleChange}>
                                                <option value="">Select Designation</option>
                                                <option value="Registered Nurse">Registered Nurse</option>
                                                <option value="Dispenser">Dispenser</option>
                                            </select>
                                            <label>Designation</label>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-floating form-floating-outline">
                                            <input type="text" className="form-control" name="rnPlace" value={formData.rnPlace || ""} onChange={handleChange} />
                                            <label>Place of Administration</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default RelocationForm;